import type { TimeFormat, TimeZone } from '../components/TimeSettingsDropDown';

type DateValue = string | Date;

const toDate = (value: DateValue): Date => (value instanceof Date ? value : new Date(value));

const pad = (value: number): string => value.toString().padStart(2, '0');

export const formatWorklogTime = (
  value: DateValue,
  timeZone: TimeZone,
  timeFormat: TimeFormat
): string => {
  const date = toDate(value);
  const hours = timeZone === 'utc' ? date.getUTCHours() : date.getHours();
  const minutes = timeZone === 'utc' ? date.getUTCMinutes() : date.getMinutes();

  if (timeFormat === '12h') {
    const ampm = hours >= 12 ? 'pm' : 'am';
    return `${hours % 12 || 12}:${pad(minutes)} ${ampm}`;
  }

  return `${pad(hours)}:${pad(minutes)}`;
};

export const formatWorklogDuration = (startValue: DateValue, endValue: DateValue): string => {
  const start = toDate(startValue);
  const end = toDate(endValue);
  const diffMs = Math.abs(end.getTime() - start.getTime());
  const totalMinutes = Math.round(diffMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${pad(hours)}:${pad(minutes)}`;
};
